module.exports = __webpack_public_path__ + "static/media/slderImg2.2b92b202.png";